import FAQSection from './FAQSection';
export default FAQSection;
